import $ from 'jquery';
const hiddenClass = '_hidden';

export default class {
  constructor($form) {
    this.$form = $form;
    this.modal = $('[data-remodal-id=feedback]').remodal();
    this.modalSuccess = $('[data-remodal-id=formSuccess]').remodal();
    this.$form.on('submit', e => this.submitForm(e));
    this.$form.find('._js-sendForm-image').on('click', e => this.clickImg(e));
  }

  // посказать следующие элементы
  submitForm(e) {
    e.preventDefault();
    const url = this.$form.attr('action');
    let data = this.$form.serialize();
    this.$form.find('[name]').css("border","2px solid #eee");
    $.post(url, data).done((response) => {

      if(response.status=='ok'){
        this.modal.close();
        this.modalSuccess.open();
        this.reloadCapchaForm();
        setTimeout(()=>{
          this.modalSuccess.close();
        }, 1500);
      }else{
        if('errName' in response){
          response.errName.forEach((v, i, ar)=>{
            this.$form.find('[name='+v+']').css("border","2px solid #f00");
          });
        }
      }
    });
  }
  clickImg(e){
    e.preventDefault();
    let img = $(e.target);
    let inputCode = img.closest('._js-sendForm-capcha').find('[name=form_code]');
    let inputHash = img.closest('._js-sendForm-capcha').find('[name=form_hash]');
    this.reloadCapcha(img, inputHash, inputHash);
    return false;
  }
  reloadCapcha(img, inputHash, inputCode) {

    let form = inputHash.closest('form');
    $.get(form.attr('action'), {getCaptcha: "1"}).done((response) => {
      img.attr('src', response.img);
      inputCode.val('');
      inputHash.val(response.hash);
    });
  }
  reloadCapchaForm() {
    let form = this.$form;
    $.get(form.attr('action'), {getCaptcha: "1"}).done((response) => {
      form.find('._js-sendForm-image').attr('src', response.img);
      form.find('[name=form_code]').val('');
      form.find('[name=form_hash]').val(response.hash);
    });
  }

  // скрыть кнопку
  hideButton() {
    this.$buttonOuter.addClass(hiddenClass);
  }
}
